import {useState} from "react";
import { Search, Star, Start } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, FormLabel, GridLegacy as Grid, Input, Popper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { ConverProductoValues } from "../../hooks/useCalculatePedido";
import { FormatPrice } from "../../utils/constants";



const  InputFulterProduct = ({
    is_opened,
    onSearchProduct=()=>{},
    onClose=()=>{},
    listResult=[],
    configClient,
    onAddItem

})=>{

    const [textInput,setTextInput] = useState("");
    //const [listResult,setListResult] = useState([]);

    const onSearchItems = ()=>{
      
        onSearchProduct({},textInput);
    };
    const detectEnterKey = (e)=>{
        if (e.key === 'Enter' || e.keyCode === 13) {
            onSearchProduct({},textInput);
        }
    }
    
    const newListResult = listResult.map(prod=>({...ConverProductoValues({...prod,cantidad:1},configClient)}));
    console.log({newListResult});
    return (
        <Dialog
         maxWidth="md"
         fullWidth
         open={is_opened}
        >
            <DialogContent>
                <Grid container  >
                <Grid item sm={12} sx={12} md={12} >
                   <Typography variant="h6">Buscar producto</Typography>
                </Grid>
                <Grid item sm={8} sx={8} md={5} >
                <FormLabel>Buscar producto</FormLabel><br/>
                <Input onKeyUp={detectEnterKey} fullWidth   onChange={e=>setTextInput(e.target.value)}  /> 
                </Grid>
                <Grid item sm={8} sx={8} md={4} alignItems={"center"} display={"flex"} >
                <Button onClick={onSearchItems} size="small" variant="contained" ><Search />Buscar</Button>
                </Grid>
                <Grid item sm={12} sx={12} md={12} >
                    <TableContainer >
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>COD ERP</TableCell>
                                    <TableCell>DESCRIPCION</TableCell>
                                    <TableCell>EXISTENCIA</TableCell>
                                    <TableCell>PRECIO REGULAR</TableCell>
                                    <TableCell>VLR. DESC</TableCell>
                                    <TableCell>PRECIO VENTA</TableCell>
                                    <TableCell></TableCell>
                                    
                                </TableRow>
                                
                            </TableHead>
                            <TableBody>
                                {
                                    newListResult.map(prod=> <TableRow key={prod.cod_oferta} >
                                        <TableCell>{prod.cod_erp_producto}</TableCell>
                                        <TableCell>{prod.es_especial === 'SI'?<Star color="primary" />:null}{prod.label}</TableCell>
                                        <TableCell>{prod.total_disponible_inv} {prod.cod_erp_unidad_medida}</TableCell>
                                       <TableCell>$ {FormatPrice(prod.precio_venta_retail,0)}</TableCell>
                                        <TableCell>$ {FormatPrice(prod.total_discount,0)}</TableCell>
                                        <TableCell>$ {FormatPrice(prod.precio_venta_final,0)}</TableCell>
                                        <TableCell><Button onClick={e=>onAddItem({
                                            producto:prod,
                                            key:prod.cod_oferta,
                                            cantidad:1
                                        })} variant="contained" color="primary" size="small" >Agregar</Button></TableCell>
                                       
                                    </TableRow>)
                                }
                                
                            </TableBody>

                        </Table>

                    </TableContainer>
                  
                </Grid>
            </Grid>
            </DialogContent>
            <DialogActions>
                <Button type="button" onClick={onClose} size="small" color="secondary" variant="contained" >Cancelar</Button>
            </DialogActions>
        </Dialog>
    )


}

export  {InputFulterProduct};